// extracted by mini-css-extract-plugin
export default {"PanelContainer":"COx2OQIz"};